import {
  Award,
  BookOpen,
  Briefcase,
  Building,
  Calendar,
  Car,
  FileText,
  Folder,
  Globe,
  GraduationCap,
  Heart,
  CircleHelp,
  House,
  Image,
  LayoutTemplate,
  Mail,
  MapPin,
  MessageCircle,
  Music,
  Newspaper,
  Package,
  Phone,
  Rows3,
  Settings,
  ShoppingBag,
  Sparkles,
  Star,
  Tag,
  User,
  Users,
  UtensilsCrossed,
  Video,
  type LucideIcon,
} from 'lucide-react';

/**
 * Иконки типов в меню — пара к набору сервера (internal/content/icons.go).
 * Имя, которого здесь нет, показывается иконкой по виду типа: пустое место
 * в меню хуже неточной картинки.
 */
export const TYPE_ICONS: Record<string, LucideIcon> = {
  rows: Rows3,
  'file-text': FileText,
  newspaper: Newspaper,
  calendar: Calendar,
  users: Users,
  user: User,
  briefcase: Briefcase,
  'shopping-bag': ShoppingBag,
  package: Package,
  tag: Tag,
  star: Star,
  heart: Heart,
  award: Award,
  image: Image,
  video: Video,
  music: Music,
  'book-open': BookOpen,
  'graduation-cap': GraduationCap,
  'message-circle': MessageCircle,
  'help-circle': CircleHelp,
  'map-pin': MapPin,
  building: Building,
  home: House,
  phone: Phone,
  mail: Mail,
  globe: Globe,
  layout: LayoutTemplate,
  settings: Settings,
  folder: Folder,
  utensils: UtensilsCrossed,
  car: Car,
  sparkles: Sparkles,
};

/** Иконка типа: выбранная в «Моделях», иначе — по виду. */
export function typeIcon(type: { icon: string; kind: string }, size?: number) {
  const Icon = TYPE_ICONS[type.icon] ?? (type.kind === 'single' ? FileText : Rows3);

  return <Icon {...(size === undefined ? {} : { size })} />;
}
